import * as CONSTRUCTOR from '../../generate';
import * as Fragments from './fragments';

export const GET_SHARED_NOTE = (props = {}) => {
  const defaultProps = {
    type: 'query',
    name: 'getSharedNote',
    operationName: 'getSharedNote',
    args: [
      { name: 'shared_note_id', type: 'String', required: true },
    ],
    argsMap: [
      { name: 'shared_note_id', value: 'shared_note_id' },
    ],
    fields: '{...SharedNoteResponseFields}',
    fragments: [Fragments.sharedNoteResponse],
  };
  let options = defaultProps;
  if (props) options = Object.assign(defaultProps, props);
  return CONSTRUCTOR.GRAPHQL(options);
};

export const LIST_SHARED_NOTES = (props = {}) => {
  const defaultProps = {
    type: 'query',
    name: 'listSharedNotes',
    operationName: 'listSharedNotes',
    args: [
      { name: 'parent_type', type: 'String', required: true },
      { name: 'parent_id', type: 'String', required: true },
      { name: 'limit', type: 'Int' },
      { name: 'page', type: 'Int' },
    ],
    argsMap: [
      { name: 'parent_type', value: 'parent_type' },
      { name: 'parent_id', value: 'parent_id' },
      { name: 'limit', value: 'limit' },
      { name: 'page', value: 'page' },
    ],
    fields: '{...SharedNotesListResponseFields}',
    fragments: [Fragments.sharedNotesListResponse],
  };
  let options = defaultProps;
  if (props) options = Object.assign(defaultProps, props);
  return CONSTRUCTOR.GRAPHQL(options);
};
